import { TestAnalysis } from './testAnalysis';
import { Version } from './version';

export class TestSpecification {
	public uid: string;

	public itemNo: string;

	public name: string;

	public version: number;

	public owners: string[];

	public testAnalyses: TestAnalysis[];

	public approvalStatus: number;

	public regTime: Date;

	public regBy: string;

	public versions: Version;
}
